module.exports = "/assets/f1f935a8b5ff9aa30b4f0ff08e46f878.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Z2.png
// module id = 2049
// module chunks = 0